import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, ShoppingBag, Brain, FileText, Utensils } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen size={24} strokeWidth={1.5} data-id="element-228" />,
    title: 'Guía Paso a Paso',
    desc: 'El protocolo de 7 días detallado para desinflamar tu cuerpo.'
  }, {
    icon: <ShoppingBag size={24} strokeWidth={1.5} data-id="element-229" />,
    title: 'Lista de Compras 40+',
    desc: 'Qué elegir en el súper para sanar tu intestino.'
  }, {
    icon: <Brain size={24} strokeWidth={1.5} data-id="element-230" />,
    title: 'Método de Reset de Cortisol',
    desc: 'Técnicas científicas para bajar el estrés biológico.'
  }, {
    icon: <FileText size={24} strokeWidth={1.5} data-id="element-231" />,
    title: 'Diario de Hinchazón',
    desc: 'Para identificar qué alimentos argentinos están saboteando tu abdomen.'
  }, {
    icon: <Utensils size={24} strokeWidth={1.5} data-id="element-232" />,
    title: 'Recetario de Almuerzos y Cenas Enzimáticas',
    desc: 'Platos reales, saciantes y desinflamatorios.'
  }];
  return <section className="py-20 md:py-32 bg-sage/20" data-id="element-233">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-234">
        <FadeIn data-id="element-235">
          <div className="text-center mb-16" data-id="element-236">
            <h2 className="font-serif text-3xl md:text-4xl text-teal mb-4" data-id="element-237">
              Lo que recibís hoy
            </h2>
            <p className="text-teal/70 font-light text-lg" data-id="element-238">
              Todo lo que necesitás para tu transformación de 7 días.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-239">
          {deliverables.map((item, index) => <FadeIn key={index} delay={0.1 * index} className={index === 4 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-240">
              <div className="bg-white p-8 rounded-xl shadow-sm border border-teal/5 h-full transition-all duration-300 hover:shadow-md hover:-translate-y-1 group" data-id="element-241">
                <div className="w-12 h-12 bg-beige/50 rounded-full flex items-center justify-center text-teal mb-6 group-hover:bg-gold/20 group-hover:text-gold transition-colors" data-id="element-242">
                  {item.icon}
                </div>
                <h3 className="font-serif text-xl text-teal mb-3" data-id="element-243">
                  {item.title}
                </h3>
                <p className="text-teal/70 font-light leading-relaxed" data-id="element-244">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}